module.exports = {"TXTCLI_Confirm_Details":{"id":"TXTCLI_Confirm_Details","defaultMessage":"Adatok megerősítése","track":"Confirm Details"}}